import fetch from 'isomorphic-fetch'
import md5 from 'js-md5'

const APIMB_ENTRYPOINT=process.env.REACT_APP_MOJBUS_API_PATH
var mbApiUser=''
var mbApiKey=''

export function fetchMB (entrypoint, jsonData, needAuthorize=true){
  const strBody=JSON.stringify(jsonData);
  var reqPath=APIMB_ENTRYPOINT + entrypoint
  var headers={
    'Content-Type': 'text/plain',
  }
  if (needAuthorize){
    var apiUser=mbApiUser
    var apiKey=mbApiKey
    //console.log('ApiUser'+mbApiUser)
    var password = md5(apiUser + strBody + apiKey)
    var base64encodedData = new Buffer(apiUser + ':' + password).toString('base64');
    headers={
      ...headers,
      'Authorization': 'Basic ' + base64encodedData
    }
  }
  var reqOptions={
    method: 'POST',
    mode: 'cors',
    redirect: 'follow',
    //credentials: 'omit',
    body: strBody,
    headers: new Headers(headers)
  }
  console.log('Entry point: ', entrypoint);
  // console.log('Request body: ', strBody);

  var request=new Request(reqPath, reqOptions);
  let funcError=function(error){
    return {
      status: 'Error',
      errorNo: 999,
      errorMessage: 'Błąd dostępu do API'
    }
  }
  // console.log('Request', request)
  return fetch(request)
  .then(
    function(response){
      return response.json();
    },
    funcError
  )
}
export function setAuthData (apiUser, apiKey) {
  mbApiUser=apiUser;
  mbApiKey=apiKey;
}
export function clearAuthData () {
  mbApiUser='';
  mbApiKey='';
}
export function getApiUserName() {
  return mbApiUser;
}



// WEBPACK FOOTER //
// ./src/utils/MojBus.js